export const getLink = (link) =>
    link?.includes('http') ? link : `https://${link}`;
